export default {
    TYPE_FIELD_INPUT: 'input',
    TYPE_FIELD_SELECT: 'select',
    TYPE_FIELD_TEXTAREA: 'textarea',

    SKU: "pos_custom_sale",
    PRODUCT_ID_PATH: "custom_sale_product_id",
}


// WEBPACK FOOTER //
// ./src/view/constant/custom-sale/CustomSaleConstant.js